import { GpsLogDeviceGroup } from './gps-log-device-group.model';
import { GpsLogItem } from './gps-log-item.model';

export class GpsLogDateGroup {
    date: Date;
    devices: GpsLogDeviceGroup[] = [];

    constructor(item: GpsLogItem) {
        this.date = item.timestamp.toDate();
        this.devices.push(new GpsLogDeviceGroup(item));
    }
}
